import React, {
    FC,
    Fragment,
    memo,
    useCallback,
    useEffect,
    useState
} from "react";
import { useDispatch, useSelector } from "react-redux";

export interface StepItem {
    step: number,
    component: any,
    props: any
}

interface StepManagerProps {
    config: StepItem[],
    defaultStep: number,
    stepName?: string,
    closeModal?: any
    onNext?: (val: any) => void
    onPrev?: (val: any) => void
    onGoToStep?: (val: any) => void
}

const DEFAULT_STEP = 1

export const StepManager: FC<StepManagerProps> = memo((props) => {
    const { closeModal, config, defaultStep: externalStep, onNext, stepName, onPrev, onGoToStep, ...rest } = props
    const [step, setStep] = useState(DEFAULT_STEP);
    const sharedData: any = useSelector<any>(store => store.getSharedData)
    const dispatch = useDispatch()
    const defaultStep = stepName && sharedData && sharedData[stepName] !== undefined
        ? sharedData[stepName]
        : externalStep

    useEffect(() => () => {
        setStep(DEFAULT_STEP)
        const goToStepAction: any = goToStep(DEFAULT_STEP)
        if(!goToStepAction) {
            return
        }
        dispatch(goToStep(DEFAULT_STEP))
    }, [])

    useEffect(() => {
        if (defaultStep !== undefined)
            setStep(defaultStep);
    }, [defaultStep]);

    const nextStep = useCallback(() => {
        if (typeof (onNext) === 'function') {
            onNext(step + 1)
        } else {
            setStep(step + 1);
        }
    }, [step, onNext]);

    const prevStep = useCallback(() => {
        if (typeof (onPrev) === 'function') {
            onPrev(step - 1)
        } else {
            setStep(step - 1);
        }
    }, [step, onPrev]);

    const goToStep = useCallback((step: number) => {
        if (typeof (onGoToStep) === 'function') {
            onGoToStep(step)
        } else {
            setStep(step);
        }
    }, [onGoToStep]);

    return <>
        {
            config?.length
                ? config?.map((item) =>
                    <Fragment key={item.step}>
                        {
                            (step === item.step) &&
                            React.createElement(item.component, {
                                nextStep,
                                prevStep,
                                goToStep,
                                closeModal,
                                ...item.props,
                                ...rest
                            })
                        }
                    </Fragment>
                )
                : undefined
        }
    </>
});
import React, {
    FC,
    Fragment,
    memo,
    useCallback,
    useEffect,
    useState
} from "react";
import { useDispatch, useSelector } from "react-redux";

export interface StepItem {
    step: number,
    component: any,
    props: any
}

interface StepManagerProps {
    config: StepItem[],
    defaultStep: number,
    stepName?: string,
    closeModal?: any
    onNext?: (val: any) => void
    onPrev?: (val: any) => void
    onGoToStep?: (val: any) => void
}

const DEFAULT_STEP = 1

export const StepManager: FC<StepManagerProps> = memo((props) => {
    const { closeModal, config, defaultStep: externalStep, onNext, stepName, onPrev, onGoToStep, ...rest } = props
    const [step, setStep] = useState(DEFAULT_STEP);
    const sharedData: any = useSelector<any>(store => store.getSharedData)
    const dispatch = useDispatch()
    const defaultStep = stepName && sharedData && sharedData[stepName] !== undefined
        ? sharedData[stepName]
        : externalStep

    useEffect(() => () => {
        setStep(DEFAULT_STEP)
        const goToStepAction: any = goToStep(DEFAULT_STEP)
        if(!goToStepAction) {
            return
        }
        dispatch(goToStep(DEFAULT_STEP))
    }, [])

    useEffect(() => {
        if (defaultStep !== undefined)
            setStep(defaultStep);
    }, [defaultStep]);

    const nextStep = useCallback(() => {
        if (typeof (onNext) === 'function') {
            onNext(step + 1)
        } else {
            setStep(step + 1);
        }
    }, [step, onNext]);

    const prevStep = useCallback(() => {
        if (typeof (onPrev) === 'function') {
            onPrev(step - 1)
        } else {
            setStep(step - 1);
        }
    }, [step, onPrev]);

    const goToStep = useCallback((step: number) => {
        if (typeof (onGoToStep) === 'function') {
            onGoToStep(step)
        } else {
            setStep(step);
        }
    }, [onGoToStep]);

    return <>
        {
            config?.length
                ? config?.map((item) =>
                    <Fragment key={item.step}>
                        {
                            (step === item.step) &&
                            React.createElement(item.component, {
                                nextStep,
                                prevStep,
                                goToStep,
                                closeModal,
                                ...item.props,
                                ...rest
                            })
                        }
                    </Fragment>
                )
                : undefined
        }
    </>
});
